import { Flex, Spinner } from '@chakra-ui/react';

export const Loader = (): JSX.Element => (
  <Flex alignItems="center" h="100vh" justifyContent="center" w="full">
    <Spinner color="brand.red.dark" size="xl" />
  </Flex>
);

export const SectionLoader = (): JSX.Element => (
  <Flex alignItems="center" h="100%" justifyContent="center" w="100%">
    <Spinner color="brand.red.dark" size="xl" />
  </Flex>
);

export const CtaLoader = (): JSX.Element => (
  <Flex alignItems="center" justifyContent="center" w="100%">
    <Spinner color="white" size="md" />
  </Flex>
);
